export const fmtSec = (v: number | null | undefined, digits = 2): string =>
    v === null || v === undefined || Number.isNaN(v) ? '—' : `${Number(v).toFixed(digits)} s`;

export const fmtMs = (v: number | null | undefined): string =>
    v === null || v === undefined || Number.isNaN(v) ? '—' : `${Math.round(Number(v))} ms`;

export const fmtBytes = (v: number | null | undefined): string => {
    if (v === null || v === undefined || Number.isNaN(v)) return '—';
    const n = Number(v);
    if (n < 1024) return `${n} B`;
    if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
    return `${(n / 1024 / 1024).toFixed(2)} MB`;
};

export const fmtPct = (v: number | null | undefined, digits = 1): string =>
    v === null || v === undefined || Number.isNaN(v) ? '—' : `${(Number(v) * 100).toFixed(digits)}%`;

export const fmtNum = (v: number | null | undefined, digits = 0): string =>
    v === null || v === undefined || Number.isNaN(v)
        ? '—'
        : Number(v).toLocaleString('en-US', { maximumFractionDigits: digits, minimumFractionDigits: digits });

export const fmtRatio = (v: number | null | undefined, digits = 3): string =>
    v === null || v === undefined || Number.isNaN(v) ? '—' : Number(v).toFixed(digits);

export const fmtDateTime = (iso: string | null | undefined): string => {
    if (!iso) return '—';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    });
};

export const fmtSize = (w: number | null | undefined, h: number | null | undefined): string =>
    w && h ? `${w}×${h}` : '—';

export const fmtBool = (v: boolean | null): string => (v === null ? '—' : v ? 'Yes' : 'No');
